import { api, buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const reviewsApi = buildService('/claims/{id}/notes_and_assumptions/{id}/notes_and_assumption_reviews', {
  only: ['all', 'update']
});
const notesAndAssumptionReviewsService = {
  useFetchHistory: (setLoading, claimId, noteId) => {
    const [history, setHistory, fetchHistory] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId || !noteId) return [];
        const response = await reviewsApi.all(claimId, noteId);
        return Array.isArray(response) ? response : [];
      }, [claimId, noteId]),
      setLoading,
      initialStateValue: []
    });
    return [history, setHistory, fetchHistory];
  },
  useUpdate: (setLoading, claimId, fetchNotes) => {
    const updateReview = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          noteId,
          reviewId,
          data
        } = _ref;
        if (!claimId || !noteId || !reviewId) return;
        const response = await reviewsApi.update(claimId, noteId, reviewId, {
          notes_and_assumption_review: data
        });
        await fetchNotes();
        return response;
      }, [claimId, fetchNotes]),
      setLoading
    });
    return [updateReview];
  }
};
notesAndAssumptionReviewsService.useCrud = (setLoading, claimId, noteId, fetchNotes) => {
  const [history, setHistory, fetchHistory] = notesAndAssumptionReviewsService.useFetchHistory(setLoading, claimId, noteId);
  const [updateReview] = notesAndAssumptionReviewsService.useUpdate(setLoading, claimId, fetchNotes);
  return {
    history,
    setHistory,
    fetchHistory,
    updateReview
  };
};
export default notesAndAssumptionReviewsService;